import TrendingPostItem from './TrendingPostItem'

export  default  TrendingPostItem